import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { media, colors, layout } from '@prisjakt/ui-base';
import Clickable from '@prisjakt/ui-clickable';

export const Wrapper = styled.section`
  padding: 0 ${layout.spacing.xSmall};
  margin-bottom: ${layout.spacing.xSmall};
`;

export const ListItem = styled(Clickable)`
  display: inline;
`;

type NavigationTabProps = {
  selected?: boolean;
};

export const HeaderLink = styled(Link)`
  color: ${p => p.theme.text.linkExternal};
  &:hover {
    color: ${p => p.theme.text.linkExternalHover};
  }
`;

export const NavigationTabs = styled.ul`
  display: flex;
  list-style: none;
  margin: ${layout.spacing.xSmall} 0;
`;
export const NavigationTab = styled.li<NavigationTabProps>`
  flex: 0;
  a,
  button {
    padding: ${layout.spacing.xSmall} ${layout.spacing.small};
    margin: ${layout.spacing.xSmall} 0;
    font-weight: ${p => (p.selected ? '600' : 'normal')};
    cursor: pointer;
    white-space: nowrap;
    max-width: 200px;
    text-overflow: ellipsis;
    overflow: hidden;
    color: ${p => (p.selected ? colors.darkBlue1 : colors.darkGray4)};
    box-shadow: ${p => (p.selected ? `0 2px 0 0 ${colors.yellow1}` : 'none')};
    &:hover {
      color: ${p => (p.selected ? colors.darkBlue1 : colors.lightBlue3)};
    }
    transition: box-shadow 0.3s ease-out;
  }
`;

export const NavigationLinks = styled.ul`
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  min-width: 100%;
`;

/* stylelint-disable no-descending-specificity */
export const NavigationLink = styled.li`
  width: 25%;
  min-width: 25%;
  margin-bottom: ${layout.spacing.xxSmall};
  a,
  button {
    line-height: 1.2rem;
    color: ${p => p.theme.text.linkInternal};
    cursor: pointer;
    &:hover {
      color: ${p => p.theme.text.linkInternalHover};
      text-decoration: underline;
    }
  }
  ${media.mediumDown`
    width: 33%;
    min-width: 33%;
  `}
  ${media.smallOnly`
    width: 50%;
    min-width: 50%;
  `}
`;
/* stylelint-enable no-descending-specificity */

export const HorizontalScroll = styled.div`
  overflow: auto;
`;
